import React from "react";
import clsx from "clsx";
import { HiOutlineExclamationCircle } from "react-icons/hi2";

type InputErrorProps = React.HTMLAttributes<HTMLDivElement> & {
  error?: string;
  showIcon?: boolean;
};

const InputError = ({ error, showIcon = false, className, ...props }: InputErrorProps) => {
  return (
    error && (
      <p className={clsx("flex text-sm text-error", className)} {...props}>
        {showIcon && <HiOutlineExclamationCircle className={"mr-1 mt-0.5 size-4 shrink-0 stroke-2 text-error"} />}
        {error}
      </p>
    )
  );
};

export default InputError;
